import React from "react";
import { Switch } from "react-router-dom";
import { connect } from "react-redux";
import PrivateRoute from "components/common/PrivateRoute";
import JobsList from "components/menu/master-files/job-maintenance/list";

const JobMaintenanceRouter = props => (
    <div className="px-5">
        <Switch>
            <PrivateRoute
                exact
                path={`${props.match.url}/`}
                component={JobsList}
            />
        </Switch>
    </div>
);

export default connect()(JobMaintenanceRouter);
